package co.maytes.standupbot.dashboard.features.roster

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.runtime.setValue
import co.maytes.standupbot.shared.roster.LinearEmailMatcher
import co.maytes.standupbot.shared.roster.RosterSelection
import com.varabyte.kobweb.compose.ui.Modifier

@Composable
fun ChannelRosterSection(
    store: ChannelRosterStore,
    workspaceId: String?,
    channelId: String?,
    channelName: String?,
    selected: Set<String>,
    onSelectionChange: (Set<String>) -> Unit,
    modifier: Modifier = Modifier,
    linearUsers: LinearUsersStore? = null,
) {
    var reloadTick by remember { mutableStateOf(0) }
    val currentOnSelectionChange by rememberUpdatedState(onSelectionChange)

    LaunchedEffect(workspaceId, channelId, reloadTick) {
        if (workspaceId.isNullOrBlank() || channelId.isNullOrBlank()) {
            store.clear()
            return@LaunchedEffect
        }
        store.load(workspaceId, channelId)
        (store.state as? RosterPickerState.Ready)?.let { currentOnSelectionChange(RosterSelection.defaults(it.members)) }
    }

    LaunchedEffect(workspaceId, linearUsers) {
        if (linearUsers != null && !workspaceId.isNullOrBlank()) linearUsers.loadOnce(workspaceId)
    }

    val state = store.state
    val linearState = linearUsers?.state
    val preview =
        remember(state, linearState) {
            linearPreviewFor(state, linearState)
        }

    RosterPicker(
        state = state,
        channelName = channelName,
        selected = selected,
        onSelectionChange = onSelectionChange,
        onRetry = { reloadTick++ },
        onCheckAgain = { reloadTick++ },
        modifier = modifier,
        linearPreview = preview,
    )
}

fun linearPreviewFor(state: RosterPickerState, linearState: LinearUsersState?): LinearPreview =
    when {
        linearState == null || state !is RosterPickerState.Ready -> LinearPreview.Hidden
        linearState is LinearUsersState.Idle || linearState is LinearUsersState.Loading -> LinearPreview.Loading
        linearState is LinearUsersState.NotConnected -> LinearPreview.NotConnected
        linearState is LinearUsersState.Failed -> LinearPreview.Unavailable
        linearState is LinearUsersState.Ready ->
            LinearPreview.Ready(LinearEmailMatcher.matchMembers(state.members, linearState.users))
        else -> LinearPreview.Hidden
    }
